import React, { ReactNode, VFC } from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import theme from './theme';

interface Props {
  children: ReactNode;
}
const ThemeProvider: VFC<Props> = ({ children }: Props) => {
  return (
    <EmotionThemeProvider theme={theme}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </EmotionThemeProvider>
  );
};

export default ThemeProvider;
